import axios from 'axios'
import { saveState, getSavedState, setDefaultAuthHeaders } from '@state/helpers'
import mapApiUrl from '@/src/utils/api-mapper'

export const state = {
  currentUser: getSavedState('auth.currentUser'),
  currentWell: getSavedState('auth.currentWell'),
}

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    const user = newValue
    if (user) {
      let priv = []
      user.priv.map((item) => {
        priv.push(item.privId)
      })
      user.priv = priv
    }
    state.currentUser = user
    saveState('auth.currentUser', user)
    setDefaultAuthHeaders(state)
  },
  SET_CURRENT_WELL(state, newValue) {
    state.currentWell = newValue
    saveState('auth.currentWell', newValue)
  },
  SET_AVATAR(state, newValue) {
    state.currentUser.avatar = newValue
    saveState('auth.currentUser', { ...state.currentUser, avatar: newValue })
  },
}

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser
  },
  userRole(state) {
    return state.currentUser ? state.currentUser.roleName : ''
  },
  hasPriv: (state) => (id) => {
    return state.currentUser && state.currentUser.priv.includes(id)
  },
  unitStandard(state) {
    return state.currentUser
      ? state.currentUser.unitStandard === 1
        ? 'api'
        : state.currentUser.unitStandard === 2
        ? 'apimix'
        : 'gde'
      : 'api'
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
    dispatch('validate')
  },
  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { username, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')
    return axios
      .post(mapApiUrl('/api/login'), { username, password })
      .then((response) => {
        const user = response.data.data
        dispatch('setUser', user)
        return user
      })

    // return new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     dispatch('setUser', {})
    //     resolve(true)
    //   }, 300)
    // })
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit('SET_CURRENT_USER', null)
    commit('SET_CURRENT_WELL', null)
    window.localStorage.clear()
  },

  // Set current user.
  setUser({ commit }, user) {
    commit('SET_CURRENT_USER', user)
  },

  // Set current user.
  setAvatar({ commit }, avatar) {
    commit('SET_AVATAR', avatar)
  },

  // Set current well.
  setWell({ commit }, well) {
    commit('SET_CURRENT_WELL', well)
  },

  // register the user
  register({ commit, dispatch, getters }, { fullname, email, password } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios
      .post(mapApiUrl('/api/register'), { fullname, email, password })
      .then((response) => {
        const user = response.data
        return user
      })
  },

  // register the user
  resetPassword({ commit, dispatch, getters }, { email } = {}) {
    if (getters.loggedIn) return dispatch('validate')

    return axios.post(mapApiUrl('/api/reset'), { email }).then((response) => {
      const message = response.data
      return message
    })
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  validate({ commit, state }) {
    if (!state.currentUser) return Promise.resolve(null)

    // const url = 'https://my-json-server.typicode.com/isnur/fake-data/user';
    // return axios
    //   .get(url, { params: {username: state.currentUser.username} })
    //   .then((response) => {
    //     const user = response.data
    //     if (user.length > 0) {
    //       commit('SET_CURRENT_USER', user[0])
    //       return user
    //     }
    //   })
    //   .catch((error) => {
    //     if (error.response && error.response.status === 401) {
    //       commit('SET_CURRENT_USER', null)
    //     }
    //     return null
    //   })
  },

  wellInfo({ commit, dispatch }, { wellInfo }) {
    if (!state.currentUser) return Promise.resolve(null)
    dispatch('setwell', wellInfo)
  },
}
